
export default {
  props: ['title', 'info', 'infoBig', 'img', 'white', 'subTitle', 'btn', 'btnName', 'imgHeight', 'product', 'readMore', 'color', 'top'],
  data () {
    return {
      load: true
    }
  }
}
